import { render, staticRenderFns } from "./PeiInitialLocation.vue?vue&type=template&id=22452dd0"
import script from "./PeiInitialLocation.vue?vue&type=script&lang=js"
export * from "./PeiInitialLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports